// extracted by mini-css-extract-plugin
module.exports = {"root":"NumberToggle_root__V_ZQy","button":"NumberToggle_button__XYVpU","disabled":"NumberToggle_disabled__u_NAj","value":"NumberToggle_value__b7SXl"};